import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { usePageTitle } from '../../hooks/usePageTitle';

export const NotFoundPage = () => {
  usePageTitle('Seite nicht gefunden');
  const navigate = useNavigate();

  return (
    <Stack direction="column" spacing={10} mt={16} alignItems="center">
      <Typography variant="headingLg">Diese Seite gibt es nicht 😕</Typography>
      <Button onClick={async () => await navigate(-1)} variant="outlined">
        Zurück
      </Button>
    </Stack>
  );
};
